export default class ArrayUtil {

  find(list, itemId, fieldName) {
    for( let i = 0; i < list.length; i++ ) {
      const item = list[i]
      if(item[fieldName] === itemId) {
        return item
      }
    }
  }

  sort(list, fieldName) {
    list.sort(function(object1, object2) {
      let fieldA = object1[fieldName];
      let fieldB = object2[fieldName];

      if(fieldA === fieldB) {
        return 0
      }

      return fieldA > fieldB ? -1 : 1
    })
  }

  sortBy(list, fieldName, order = 'asc') {
    const sortedList = [...list];
    sortedList.sort(function(object1, object2) {
      let fieldA = object1[fieldName];
      let fieldB = object2[fieldName];

      // Handle null/undefined values
      if (fieldA === null || fieldA === undefined) fieldA = '';
      if (fieldB === null || fieldB === undefined) fieldB = '';

      // Handle date comparisons
      if (fieldA instanceof Date && fieldB instanceof Date) {
        fieldA = fieldA.getTime();
        fieldB = fieldB.getTime();
      }

      if(fieldA === fieldB) {
        return 0
      }

      const comparison = fieldA > fieldB ? 1 : -1;
      return order === 'asc' ? comparison : -comparison;
    });
    return sortedList;
  }

  groupBy(list, fieldName) {
    const map = {}

    for( let i = 0; i < list.length; i++ ) {
      const item = list[i]
      const fieldValue = item[fieldName]
      if(!map[fieldValue]) {
        map[fieldValue] = []
      }

      map[fieldValue].push(item)
    }

    return map
  }

  updateItem(list, item, fieldName) {
    for( let i = 0; i < list.length; i++ ) {
      if(item[fieldName] === list[i][fieldName]) {
        list[i] = item
        break
      }
    }
  }
}
